// extracted by mini-css-extract-plugin
module.exports = {"root":"ErrorMessage_root__swoeP","title":"ErrorMessage_title__NNv63","message":"ErrorMessage_message__da_LH"};